<template>
    <div class="c-avatar">
        <img v-lazy="avatar" class="c-avatar-img" />
        <div class="c-avatar-username">{{ username }}</div>
    </div>
</template>

<script>
export default {
    props: {
        avatar: {
            type: String,
            required: true
        },
        username: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.c-avatar {
    &-img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: block;
        margin: 0 auto;
        background-color: #cdcdcd;
        overflow: hidden;
    }
    &-username {
        font-size: 14px;
        margin-top: 9px;
        text-align: center;
        color: #888888;
    }
}
</style>
